import { Routes } from '@angular/router';

import { UserRouteAccessService } from '../../../services';
import { PasswordResetInitComponent } from './reset/password-reset-init.component';
import { PasswordResetFinishComponent } from './reset/password-reset-finish.component';
import { PasswordChangeComponent } from './change/password-change.component';

export const PASSWORD_ROUTES: Routes = [
    {
        path: 'reset/finish',
        component: PasswordResetFinishComponent,
        data: {
            authorities: [],
            pageTitle: 'global.menu.account.password'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'reset/request',
        component: PasswordResetInitComponent,
        data: {
            authorities: [],
            pageTitle: 'global.menu.account.password'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'password',
        component: PasswordChangeComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'global.menu.account.password'
        },
        canActivate: [UserRouteAccessService]
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/password/password.route.ts